import { ICluster, IContact } from '@nkr/models/index';
import JoditEditor from '@nkr/components/editor';
import config from '@nkr/views/ticketing/jodit-editor-config';

interface IProps {
    message: string,
    swaps: ICluster[],
    swapManager: IContact,
    onMessageChange: (message: string) => void
}

const ByMissedDeadline = (props: IProps) => {
    const handleMessageChange = (message: string) => {
        props.onMessageChange(message);
    };

    const joditConfig = { ...config, height: '300px' };

    return (
        <>
            <JoditEditor
                value={props.message}
                config={joditConfig}
                onChange={handleMessageChange}
                onBlur={() => null}
            />
            <br />

            <div style={{ marginBottom: 20 }}>
                <table>
                    <tbody>

                    </tbody>
                </table>
            </div>
        </>
    );
}

export default ByMissedDeadline;